import { createBrowserHistory, History } from "history";
import { AnyAction, Store } from "redux";

export default class ElstrCore {
  public static store: Store<any, any>;

  public static history: History = createBrowserHistory();
}

export const dispatch = (foo: AnyAction) => ElstrCore.store.dispatch(foo);
